exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "best-jobs ul li span{color:#d7731a}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/components/bestJobs/bestJobs.styl
// module id = 137
// module chunks = 0 1